export const STATUS_NORMAL = 0;
export const STATUS_DELAY = 5;
